// @ts-nocheck
import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { FullScreenLoading } from '../../../../common/components';
import { AuthCallback, AuthService, selectAuthenticated } from '../../../auth';
import { CustomerDetailsPage, CustomerSearchPage } from '../../../customers';
import { VouchersPage } from '../../../vouchers';
import { CampaignsPage, CampaignDetailsPage } from '../../../campaigns';
import { ProductsPage, ProductDetailsPage } from '../../../products';
import { ServiceMessagesPage } from '../../../messages';
import { CompaniesPage, CompanyDetailsPage, ContractDetailsPage } from '../../../companies';
import { AppRoute } from '../../constants';
import AppLayout from './AppLayout';
import { PromotionDetailsPage, PromotionsPage } from '../../../promotions';

/* eslint-disable react/prop-types */

export function PrivateRoute({ component: Component, ...rest }) {
  const authenticated = useSelector(selectAuthenticated);
  return (
    <Route
      {...rest}
      render={props => {
        const idToken = localStorage.getItem('id_token');
        if (!idToken) {
          AuthService.fetchCode();
          return <FullScreenLoading />;
        }
        if (!authenticated) {
          return (
            <Redirect
              to={{
                pathname: AppRoute.AuthCallback,
                state: { from: props.location },
              }}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
}

/* eslint-enable react/prop-types */

function AppRoutes() {
  return (
    <Router>
      <AppLayout>
        <Switch>
          <PrivateRoute exact path={AppRoute.Customers} component={CustomerSearchPage} />
          <PrivateRoute exact path={AppRoute.CustomerDetails} component={CustomerDetailsPage} />
          <PrivateRoute exact path={AppRoute.Vouchers} component={VouchersPage} />
          <PrivateRoute exact path={AppRoute.Campaigns} component={CampaignsPage} />
          <PrivateRoute exact path={AppRoute.CampaignDetails} component={CampaignDetailsPage} />
          <PrivateRoute exact path={AppRoute.ServiceMessages} component={ServiceMessagesPage} />
          <PrivateRoute exact path={AppRoute.Companies} component={CompaniesPage} />
          <PrivateRoute exact path={AppRoute.CompanyDetails} component={CompanyDetailsPage} />
          <PrivateRoute exact path={AppRoute.ContractDetails} component={ContractDetailsPage} />
          <PrivateRoute exact path={AppRoute.Products} component={ProductsPage} />
          <PrivateRoute exact path={AppRoute.ProductDetails} component={ProductDetailsPage} />
          <PrivateRoute exact path={AppRoute.Promotions} component={PromotionsPage} />
          <PrivateRoute exact path={AppRoute.PromotionDetails} component={PromotionDetailsPage} />
          <Route exact path={AppRoute.AuthCallback} component={AuthCallback} />
          <Redirect exact from={AppRoute.Index} to={AppRoute.Customers} />
        </Switch>
      </AppLayout>
    </Router>
  );
}

export default AppRoutes;
